import styled from 'styled-components';

import Icon from '@ant-design/icons';

import CommonButton from '~atoms/CommonButton';

export const Container = styled(CommonButton)<{
  $customBtnStyles?: React.CSSProperties;
}>(({ theme, $customBtnStyles }) => ({
  padding: 0,
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',

  color: theme.palette.white,
  backgroundColor: theme.palette.darkLiver,

  border: `1rem solid ${theme.palette.darkLiver}`,
  borderRadius: '50%',

  '&[data-dir="left"]': {
    left: 0,
  },
  '&[data-dir="right"]': {
    right: '2rem',
  },
  '&:not([disabled]):hover': {
    border: 'none',
    color: theme.palette.darkLiver,
    backgroundColor: theme.palette.white,
  },

  ...$customBtnStyles,
}));

export const ArrowIcon = styled(Icon)<{
  $customIconStyles?: React.CSSProperties;
}>(({ $customIconStyles }) => ({
  ...$customIconStyles,
}));
